import React, { useState, useEffect } from 'react';
import LoginHeader from './../../../Login_header';
import Menu from '../../../Menu';
import { Container, Row, Col, Button } from 'react-bootstrap';
import * as Common from './../../../Common';
import Dialog from './../../../Dialog';
import $ from "jquery";

const OpeningInwardUtilization = () => {
    const sid = sessionStorage.getItem('sessionId');
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    useEffect(() => {
        $(".loader").show();
        Common.callApi(Common.apiRight, [sid, 'all', 'REP_TT_OPENING_INWARD_UTILIZATION'], setUserRight);
        $(".loader").hide();
    }, [sid]);

    const downloadReport = () => {
        $(".loader").show();
        Common.callDownloadApiPost1(Common.apiInwardUtilization, 'post', [sid, 'download'], result => {
            $(".loader").hide();
            setMsgText('Successfully generated');
            setMsgBox(true);
        });
    };

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row className="mb-3">
                    <Col><h3>Opening Inward Utilization</h3></Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Button variant="outline-success" className="buttonStyle" size="sm" onClick={downloadReport}>Generate</Button>
                    </Col>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={() => setMsgBox(false)}>
                {msgText}
            </Dialog>
        </>
    );
};

export default OpeningInwardUtilization;